export function CloseIcon({ color, size = 24 }: { color?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill={color || "currentColor"}
        d="m9 7.94 3.713-3.713 1.06 1.06L10.06 9l3.713 3.713-1.06 1.06L9 10.06l-3.713 3.713-1.06-1.06L7.939 9 4.227 5.287l1.06-1.06z"
      />
    </svg>
  );
}
